import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";

import * as actionTypes from "./actionTypes";
import { localStorageFunc, notify} from "../../helpers/utility";

//import getEvents from '../../eventManager/event';

//localStorageFunc.set('autoBreakFlag', 'autoBreakFlag', 10);
//localStorageFunc.erase('autoReadyFlag');
//localStorageFunc.get('autoReadyFlag')

let autoAgentStateTimeout;
let autoAgentStateLoginTimeout;

const expirationDate = 86400; //new Date(new Date().getTime() + 36000000);

export const agentLoginStart = () => {
  return {
    type: actionTypes.AGENT_LOGIN_START,
  };
};

export const agentLoginSuccess = (agentId, loggedIn, loginWait) => {
  return {
    type: actionTypes.AGENT_LOGIN_SUCCESS,
    agentId: agentId,
    loggedIn: loggedIn,
    loginWait: loginWait,
  };
};

export const agentLoginFail = (error) => {
  return {
    type: actionTypes.AGENT_LOGIN_FAIL,
    error: error,
  };
};

export const agentLoginWait = (agentId, loggedIn, loginWait, loginType) => {
  return {
    type: actionTypes.AGENT_LOGIN_WAIT,
    agentId: agentId,
    loggedIn: loggedIn,
    loginWait: loginWait,
    error:
      loginType === "Webrtc"
        ? "Please pick the Web RTC call!"
        : "Please login through the phone!",
  };
};

export const agentStateUpdate = (agentId, loggedIn, loginWait, data) => {
  return {
    type: actionTypes.AGENT_STATE_UPDATE,
    agentId: agentId,
    campaignId: data.campaignId,
    loggedIn: loggedIn,
    loginWait: loginWait,
    //loginType: data.login_type,
    //Agent Data
    agentState: data.state,
    dialerType: data.dialer_type,
    campaignDialerType: data.campaign_dialerType,
    previewDialing: data.previewDialing,
    manualDial: data.manual_dial,
    initiateScreenRec: data.initiate_screen_rec,
    isHold: data.is_hold,
    holdTime: data.hold_time,
    ivrsPath: data.ivrs_path,
    sessionId: data.session_id,
    leadId: data.lead_id,
    callType: data.call_type,
    phType: data.ph_type,
    custPhone: data.cust_ph_no,
    lastCustPhone: data.last_cust_ph_no,
    callDuration: data.call_duration,
    agentName: data.agent_name,
    callBackLive: data.call_back_live,
    isEscalation: data.is_escalation,
    skills: data.skills,
    didNum: data.did_num,
    leadAttemptCount: data.lead_attempt_count,
    custUniqueId: data.CustUniqueId,
    listName: data.list_name,
    isTransfer: data.is_transfer,
    autoMode: data.autoMode,
    detail: data.detail,
    lastActivityTime: data.lastActivityTime,
    autoReadyFlag: data.autoReadyFlag,
    autoReadyTime: data.autoReadyTime,
    failedReason: data.failed_reason,
    wrapTime: data.wrapTime,
    wrpupDisconnectFlag: data.wrpupDisconnectFlag,
    breakType: data.break_type,
    callBack: data.call_back,
    pausedTime: data.pausedTime,
    allowedTime: data.allowed_time,
    agentInConf: data.agent_in_conf,
    rdFlag: data.rd_flag,
    callParkCount: data.call_park_count,
    callsInQueue: data.calls_in_queue,
    multiConfEnabled: data.multi_conf_enabled,
    mandatory: data.mandatory_disp_check,
    callCategory: data.callcategory,
    language: data.language,
    boxDate: data.box_date,
    boxTime: data.box_time,
    nextActionOnLead: data.next_action_on_lead,
    registerstatus: data.registerstatus,
  };
};

export const agentLogoutStart = () => {
  return {
    type: actionTypes.AGENT_LOGOUT_START,
  };
};

export const agentLogoutSuccess = (agentId) => {
  return {
    type: actionTypes.AGENT_LOGOUT_SUCCESS,
    agentId: agentId,
  };
};

export const agentLogoutFail = (error) => {
  return {
    type: actionTypes.AGENT_LOGOUT_FAIL,
    error: error,
  };
};

export const agentLogout = (agentId) => {
  return (dispatch) => {
    if (agentId) {
      dispatch(agentLoginStart());
      ctiRequest["LOGOUT"].agent_id = agentId;
      ctiRequest["LOGOUT"].ip = localStorageFunc.get("clientIP");
      axios
        .post("/", ctiRequest["LOGOUT"])
        .then((result) => {
          if (result.data.response.status === "SUCCESS") {
            dispatch(getAgentState(agentId));
          } else if (
            result.data.response.status === "FAILURE" &&
            result.data.response.reason ===
              "Agent is not loggedin as per the request"
          ) {
            //dispatch(getAgentState(agentId));
            localStorageFunc.erase("agentId");
            localStorageFunc.erase("loggedIn");
            localStorageFunc.erase("loginWait");
            localStorageFunc.erase("token");
            localStorageFunc.erase("refreshToken");
            localStorageFunc.erase("clientIP");

            localStorageFunc.erase("password");
            localStorageFunc.erase("extension");
            localStorageFunc.erase("reloginWait");
            localStorageFunc.erase("accessToken");
            localStorageFunc.erase("isExpired");
            localStorageFunc.erase("responseCode");
            localStorageFunc.erase("reason");
            localStorageFunc.erase("Reseterror");
            localStorageFunc.eraseAll();
            clearTimeout(autoAgentStateTimeout);
            dispatch(agentLogoutSuccess(agentId));
          } else {
            dispatch(agentLogoutFail(result.data.response.reason));
          }
        })
        .catch((err) => {
          dispatch(
            agentLogoutFail("Request Error, Please contact with Admin.")
          );
        });
    }
  };
};

export const getAgentStateTimeout = (agentId) => {
  clearTimeout(autoAgentStateTimeout);
  return (dispatch) => {
    autoAgentStateTimeout = setTimeout(() => {
      dispatch(getAgentState(agentId));
    }, 2000);
  };
};

export const getAgentStateLoginTimeout = (agentId) => {
  clearTimeout(autoAgentStateLoginTimeout);
  return (dispatch) => {
    autoAgentStateLoginTimeout = setTimeout(() => {
      dispatch(getAgentStateLogin(agentId));
    }, 2000);
  };
};

export const getAgentState = (agentId) => {
  return (dispatch) => {
    const agentId = localStorageFunc.get("agentId");

    if (!agentId) {
      dispatch(checkAgentState());
    }
    ctiRequest["CTI_CHECK_AGENT_STATE"].agent_id = agentId;
    const loggedIn = localStorageFunc.get("loggedIn") === "true";
    const token = localStorageFunc.get("token");
    const loginWait = localStorageFunc.get("loginWait") === "true";
    const loginType = localStorageFunc.get("loginType");
    ctiRequest["CTI_CHECK_AGENT_STATE"].ip = localStorageFunc.get("clientIP");
    try {
      axios
        .post("/", ctiRequest["CTI_CHECK_AGENT_STATE"])
        .then((result) => {
          //alert(token);alert(result.data.response.token);
          if (
              
            result.data.response.status === "SUCCESS" &&
            loggedIn &&
            !loginWait &&
            token === result.data.response.token
          ) {
            dispatch(
              agentStateUpdate(agentId, true, false, result.data.response)
            );
            dispatch(getAgentStateTimeout(agentId));
             if (loginType === "" || loginType === undefined || loginType === null){
              dispatch(getJanusData(agentId));
             }
            else if (loginType === "Webrtc") {
              const requiredFields = ["janus_ip", "janus_port", "clientIP", "reg_ip", "sip", "auto_answer", "secret"];
              const checkData = requiredFields.some(key => {
                const value = localStorageFunc.get(key);
                return value === undefined || value === null || value === "";
              });
              if (checkData) {
                dispatch(getJanusData(agentId));
              }
            }
          } else if (
            (result.data.response.status === "FAILURE" &&
              result.data.response.reason === "NOT_LOGGED_IN") ||
            !loggedIn ||
            token !== result.data.response.token
          ) {
            if(token !== result.data.response.token){
              window.location.reload(false)
             }
            localStorageFunc.erase("agentId");
            localStorageFunc.erase("loggedIn");
            localStorageFunc.erase("loginWait");
            localStorageFunc.erase("token");
            localStorageFunc.erase("refreshToken");
            localStorageFunc.erase("clientIP");

            localStorageFunc.erase("password");
            localStorageFunc.erase("extension");
            localStorageFunc.erase("reloginWait");
            localStorageFunc.erase("agentId");
            localStorageFunc.erase("loggedIn");
            localStorageFunc.erase("loginWait");
            localStorageFunc.erase("token");
            localStorageFunc.erase("clientIP");
            localStorageFunc.erase("sip");
            localStorageFunc.erase("secret");
            dispatch(agentLogoutSuccess(agentId));
           
          } else {
            dispatch(getAgentStateTimeout(agentId));
          }
        })
        .catch((err) => {
          dispatch(getAgentStateTimeout(agentId));
          notify("Network Error - Server is not reachable", "network-error");
        });
    } catch (err) {
      dispatch(getAgentStateTimeout(agentId));
      notify("Network Error - Server is not reachable", "network-error");
    }
  };
};

/* for janus start  */

export const getJanusData = (agentId) => {
  return (dispatch) => {
    const agentId = localStorageFunc.get("agentId");
    if (!agentId) {
      dispatch(checkAgentState());
    }
    ctiRequest["CTI_LOGIN_INFO"].agent_id = agentId;
    try {
      axios
        .post("/", ctiRequest["CTI_LOGIN_INFO"])
        .then((result) => {
          //alert(token);alert(result.data.response.token);
          if (result.data.response.status === "SUCCESS") {
            localStorageFunc.set(
              "loginType",
              result.data.response.login_type,
              expirationDate
            );
            localStorageFunc.set(
              "clientIP",
              result.data.response.ip,
              expirationDate
            );
            localStorageFunc.set(
              "token",
              result.data.response.token,
              expirationDate
            );
            localStorageFunc.set(
              "refreshToken",
              result.data.response.token,
              expirationDate
            );
            if (result.data.response.login_type === "Webrtc") {
              const webrtcDetails = result.data.response.webrtc_data;
              localStorageFunc.set(
                "sip",
               webrtcDetails.sip_pass,
                expirationDate
              );
              localStorageFunc.set(
                "auto_answer",
               webrtcDetails.auto_answer_flag,
                expirationDate
              );
              localStorageFunc.set(
                "reg_ip",
                webrtcDetails.registration_ip,
                expirationDate
              );
              localStorageFunc.set(
                "secret",
                webrtcDetails.agent_secret,
                expirationDate
              );
              localStorageFunc.set(
                "janus_ip",
               webrtcDetails.janus_server_ip,
                expirationDate
              );
              localStorageFunc.set(
                "janus_port",
               webrtcDetails.janus_port,
                expirationDate
              );
              window.location.reload();
            } else {
              localStorageFunc.set(
                "loginType",
                "Normal",
                expirationDate
              );
            }
          } else {
            console.log("Data retrieval was not successful");
          }
        })
        .catch((err) => {
          console.log(err)
    });
    } catch (err) {
      dispatch(getAgentStateTimeout(agentId));
      notify("Network Error - Server is not reachable", "network-error");
    }
  };
};


/* for janus end */

export const getAgentStateLogin = (agentId) => {
  return (dispatch) => {
    ctiRequest["CTI_CHECK_AGENT_STATE"].agent_id = agentId;
    ctiRequest["CTI_CHECK_AGENT_STATE"].ip = localStorageFunc.get("Ip");
    axios
      .post("/", ctiRequest["CTI_CHECK_AGENT_STATE"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          localStorageFunc.set("loggedIn", true, expirationDate - 60);
          localStorageFunc.erase("loginWait");
          //play play_login_file here with getElementById
          if (document.getElementById("play_login_file")) {
            document.getElementById("play_login_file").play();
          }
          console.log(Notification.permission)
         if (Notification.permission === 'default') {
          Notification.requestPermission();
        }
        
          clearTimeout(autoAgentStateLoginTimeout);
          dispatch(
            agentStateUpdate(agentId, true, false, result.data.response)
          );
          dispatch(getAgentStateTimeout(agentId));
        } else {
          dispatch(getAgentStateLoginTimeout(agentId));
        }
      })
      .catch((err) => {
        dispatch(getAgentStateLoginTimeout(agentId));
      });
  };
};

/*const handleEvent = (data) => {
  console.log(data);
}*/

export const agentLogin = (email, password, extension, action,sessiion_flag) => {
  //const emsg = getEvents(handleEvent);
  //console.log(emsg);
  return (dispatch) => {
    if (action === "newlogin") {
      localStorageFunc.erase("agentId");
      localStorageFunc.erase("loggedIn");
      localStorageFunc.erase("loginWait");
      localStorageFunc.erase("token");
      localStorageFunc.erase("refreshToken");
      localStorageFunc.erase("Ip");
      localStorageFunc.erase("password");
      localStorageFunc.erase("extension");
      localStorageFunc.erase("reloginWait");
      dispatch(agentLogoutSuccess(email));
    } else if (action === "relogin") {
      dispatch(agentLoginStart());
      ctiRequest["LOGIN_UPDATE"].agent_id = email;
      ctiRequest["LOGIN_UPDATE"].agent_pass = password;
      ctiRequest["LOGIN_UPDATE"].agent_ext = extension;
      ctiRequest["LOGIN_UPDATE"].session_flag = sessiion_flag;
      ctiRequest["LOGIN_UPDATE"].action = action;
      axios
        .post("/", ctiRequest["LOGIN_UPDATE"])
        .then((result) => {
          if (result.data.response.status === "SUCCESS") {
            //localStorageFunc.set('testing', "test", 60);
            localStorageFunc.set(
              "agentId",
              result.data.response.agent_id,
              expirationDate
            );
            localStorageFunc.set("loggedIn", false, 60);
            localStorageFunc.set("loginWait", true, 60);
            localStorageFunc.set(
              "token",
              result.data.response.token,
              expirationDate
            );
            localStorageFunc.set(
              "refreshToken",
              result.data.response.token,
              expirationDate
            );
            localStorageFunc.set(
              "clientIP",
              result.data.response.ip,
              expirationDate
            );
            localStorageFunc.set(
              "loginType",
              result.data.response.login_type,
              expirationDate
            );

            localStorageFunc.erase("password");
            localStorageFunc.erase("extension");
            localStorageFunc.erase("reloginWait");

            if (result.data.response.login_type === "Webrtc") {
              result.data.response = {
                ...result.data.response,
                ...result.data.response.webrtc_data,
              };
              window.login_flag = false;
              window.auto_answer_flag =
                result.data.response.auto_answer_flag &&
                result.data.response.auto_answer_flag === "0"
                  ? false
                  : true;
              window.agent_in_conf_flag = false;
            const janusPort = result.data.response.janus_port || 443;
              window.web_rt(
                result.data.response.agent_id,
                result.data.response.sip_pass,
                result.data.response.registration_ip,
                false,
                window.auto_answer_flag,
                result.data.response.agent_secret,
                result.data.response.janus_server_ip,
                janusPort
              );
              localStorageFunc.set(
                "sip",
                result.data.response.sip_pass,
                expirationDate
              );
              localStorageFunc.set(
                "auto_answer",
                result.data.response.auto_answer_flag,
                expirationDate
              );
              localStorageFunc.set(
                "reg_ip",
                result.data.response.registration_ip,
                expirationDate
              );
              localStorageFunc.set(
                "secret",
                result.data.response.agent_secret,
                expirationDate
              );
              localStorageFunc.set(
                "janus_ip",
                result.data.response.janus_server_ip,
                expirationDate
              );
              localStorageFunc.set(
                "janus_port",
                janusPort,
                expirationDate
              );
            }
            localStorageFunc.erase("password");
            localStorageFunc.erase("extension");
            localStorageFunc.erase("reloginWait");
            window.GLOBAL_AGENT_ID = result.data.response.agent_id;
            dispatch(getAgentStateLogin(result.data.response.agent_id));
            dispatch(
              agentLoginWait(result.data.response.agent_id, false, true, "")
            );
          } else {
            dispatch(agentLoginFail(result.data.response.reason));
          }
        })
        .catch((err) => {
          dispatch(agentLoginFail("Request Error, Please contact with Admin."));
        });
    } else {
      dispatch(agentLoginStart());
      ctiRequest["LOGIN"].agent_id = email;
      ctiRequest["LOGIN"].agent_pass = password;
      ctiRequest["LOGIN"].agent_ext = extension;
      ctiRequest["LOGIN"].session_flag = sessiion_flag;
      ctiRequest["LOGIN"].action = action;
      axios
        .post("/", ctiRequest["LOGIN"])
        .then((result) => {
          //console.log(result);
          if (result.data.response.status === "SUCCESS") {
            if (result.data.response.login_type === "Webrtc") {
              result.data.response = {
                ...result.data.response,
                ...result.data.response.webrtc_data,
              };
              window.login_flag = false;
              window.auto_answer_flag =
                result.data.response.auto_answer_flag &&
                result.data.response.auto_answer_flag === "0"
                  ? false
                  : true;
              window.agent_in_conf_flag = false;
              const janusPort = result.data.response.janus_port || 443;
              window.web_rt(
                result.data.response.agent_id,
                result.data.response.sip_pass,
                result.data.response.registration_ip,
                false,
                window.auto_answer_flag,
                result.data.response.agent_secret,
                result.data.response.janus_server_ip,
                janusPort
              );
              localStorageFunc.set(
                "sip",
                result.data.response.sip_pass,
                expirationDate
              );
              localStorageFunc.set(
                "auto_answer",
                result.data.response.auto_answer_flag,
                expirationDate
              );
              localStorageFunc.set(
                "reg_ip",
                result.data.response.registration_ip,
                expirationDate
              );
              localStorageFunc.set(
                "secret",
                result.data.response.agent_secret,
                expirationDate
              );
              localStorageFunc.set(
                "janus_ip",
                result.data.response.janus_server_ip,
                expirationDate
              );
              localStorageFunc.set(
                "janus_port",
                janusPort,
                expirationDate
              );
            }
            localStorageFunc.set(
              "agentId",
              result.data.response.agent_id,
              expirationDate
            );
            localStorageFunc.set("loggedIn", false, 60);
            localStorageFunc.set("loginWait", true, 60);
            localStorageFunc.set(
              "token",
              result.data.response.token,
              expirationDate
            );
            localStorageFunc.set(
              "refreshToken",
              result.data.response.token,
              expirationDate
            );
            localStorageFunc.set(
              "clientIP",
              result.data.response.ip,
              expirationDate
            );
            localStorageFunc.set(
              "loginType",
              result.data.response.login_type,
              expirationDate
            );

            localStorageFunc.erase("password");
            localStorageFunc.erase("extension");
            localStorageFunc.erase("reloginWait");
            dispatch(getAgentStateLogin(result.data.response.agent_id));
            dispatch(
              agentLoginWait(
                result.data.response.agent_id,
                false,
                true,
                result.data.response.login_type
              )
            );
          } else if (
            result.data.response.reason === "Agent already logged in"
          ) {
            localStorageFunc.set("agentId", result.data.response.agent_id, 60);
            localStorageFunc.set("password", password, 60);
            localStorageFunc.set("extension", password, 60);
            localStorageFunc.set("loggedIn", false, 60);
            localStorageFunc.set("reloginWait", true, 60);
            dispatch(agentLoginFail("ReloginAgent"));
          } else {
            dispatch(agentLoginFail(result.data.response.reason));
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch(agentLoginFail("Request Error, Please contact with Admin."));
        });
    }
  };
};



export const checkAgentState = () => {
  return (dispatch) => {
    const agentId = localStorageFunc.get("agentId");
    const loggedIn = localStorageFunc.get("loggedIn") === "true";
    const loginWait = localStorageFunc.get("loginWait") === "true";
    const loginType = localStorageFunc.get("loginType");

    if (agentId && loggedIn && !loginWait) {
      if (loginType === "Webrtc") {

        window.login_flag = true;
        window.agent_in_conf_flag = false;
        window.auto_answer_flag =
          localStorageFunc.get("auto_answer") === "0" ? false : true;
          const janusPort = localStorageFunc.get("janus_port") || "443";
        window.web_rt(
          agentId,
          localStorageFunc.get("sip"),
          localStorageFunc.get("reg_ip"),
          true,
          window.auto_answer_flag,
          localStorageFunc.get("secret"),
          localStorageFunc.get("janus_ip"),
          janusPort
        );
      }
      else if (loginType || loginType === "" || loginType === undefined || loginType === null){
        dispatch(getJanusData(agentId));
      }

      dispatch(getAgentState(agentId));
    } else if (!agentId) {
      localStorageFunc.erase("agentId");
      localStorageFunc.erase("loggedIn");
      localStorageFunc.erase("loginWait");
      localStorageFunc.erase("token");
      localStorageFunc.erase("refreshToken");
      localStorageFunc.erase("clientIP");
      localStorageFunc.erase("password");
      localStorageFunc.erase("extension");
      localStorageFunc.erase("reloginWait");
      localStorageFunc.erase("agentId");
      localStorageFunc.erase("loggedIn");
      localStorageFunc.erase("loginWait");
      localStorageFunc.erase("token");
      localStorageFunc.erase("clientIP");
      localStorageFunc.erase("sip");
      localStorageFunc.erase("secret");
      clearTimeout(autoAgentStateTimeout);
      dispatch(agentLogoutSuccess(agentId));
    } else if (!loginWait) {
      clearTimeout(autoAgentStateTimeout);
      dispatch(agentLogout(agentId));
    }
  };
};
